/**
 * @generated SignedSource<<749bc09ee809fcdd14207bf5c8590942>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ClickupFolderSelectorQuery$variables = {
  spaceId: string;
};
export type ClickupFolderSelectorQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly clickup: {
        readonly folders: ReadonlyArray<{
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }> | null;
      } | null;
    };
  };
};
export type ClickupFolderSelectorQuery = {
  response: ClickupFolderSelectorQuery$data;
  variables: ClickupFolderSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "spaceId",
      "variableName": "spaceId"
    }
  ],
  "concreteType": "ClickupFolderNode",
  "kind": "LinkedField",
  "name": "folders",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClickupFolderSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClickupUserNode",
                "kind": "LinkedField",
                "name": "clickup",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClickupFolderSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClickupUserNode",
                "kind": "LinkedField",
                "name": "clickup",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "50794f9232b6d27f0b7c54f42658bb62",
    "id": null,
    "metadata": {},
    "name": "ClickupFolderSelectorQuery",
    "operationKind": "query",
    "text": "query ClickupFolderSelectorQuery(\n  $spaceId: String!\n) {\n  viewer {\n    integrations {\n      clickup {\n        folders(spaceId: $spaceId) {\n          id\n          name\n          externalId\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b13e96514fe6519704891ebb0ddff873";

export default node;
